import { loginApiV1AuthLoginPost } from '@/common/api/client/sdk.gen'
import type {
    LoginApiV1AuthLoginPostData,
    LoginApiV1AuthLoginPostError,
    LoginApiV1AuthLoginPostResponse,
} from '@/common/api/client/types.gen'
import { useFormMutation } from '@/common/hooks/useFormMutation'
import { setHeaderToken } from '@/common/lib/fetch'
import { resolvePostAuthRedirect } from '@/common/lib/safeRedirect'
import { YandexMetrica } from '@/common/lib/yandexMetrica'
import { useQueryClient } from '@tanstack/react-query'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { ROUTES } from '../lib/constants'

const clearAuthState = () => {
    localStorage.removeItem('current_org_id')
}

export const useLogin = () => {
    const navigate = useNavigate()
    const [searchParams] = useSearchParams()
    const emailFromQuery = searchParams.get('email') ?? ''
    const queryClient = useQueryClient()

    const { mutation, onSubmit, register, handleSubmit, errors, form } = useFormMutation<
        LoginApiV1AuthLoginPostData['body'],
        LoginApiV1AuthLoginPostResponse,
        LoginApiV1AuthLoginPostError
    >({
        mutationFn: data => loginApiV1AuthLoginPost({ body: data }).then(r => r.data!),
        formOptions: {
            defaultValues: {
                email: emailFromQuery,
                password: '',
            },
        },
        toastOptions: {
            successMessage: 'Вы вошли в систему',
        },
        onSuccess: data => {
            YandexMetrica.reachGoal('auth_success')
            queryClient.clear()
            clearAuthState()
            setHeaderToken(data.access_token, data.refresh_token)
            navigate(resolvePostAuthRedirect(searchParams.toString(), ROUTES.APP))
        },
        onError: () => {
            queryClient.clear()
            clearAuthState()
        },
    })

    return {
        mutation,
        register,
        handleSubmit,
        errors,
        onSubmit,
        setFocus: form.setFocus,
        emailFromQuery,
    }
}
